import { AxiosClient } from "@/app/shared/services";
import moment from 'moment';

const state = {
    filters: {
        id: { value: "", typeOfSearch: ""},
        email: { value: "", typeOfSearch: ""},
        phone: { value: "", typeOfSearch: ""},
        name: { value: "", typeOfSearch: ""},
        registerDate: { from: moment().format("YYYY-MM-DD"), to: moment().add(1, 'days').format("YYYY-MM-DD") },
        aff_sub1: { value: "", typeOfSearch: ""},
        aff_sub2: { value: "", typeOfSearch: ""},
        aff_sub3: { value: "", typeOfSearch: ""},
        aff_sub4: { value: "", typeOfSearch: ""},
        aff_sub5: { value: "", typeOfSearch: ""},
        utm_source: { value: "", typeOfSearch: ""},
        utm_campaign: { value: "", typeOfSearch: ""},
        is_sms_blocked: "",
        is_call_blocked: "",
        sms_count_before_ban: "",
        sms_count_after_ban: "",
        call_count_before_ban: "",
        call_count_after_ban: "",
    },
    showColumns: {
        name: true,
        surname: false,
        second_name: false,
        created_at: true,
        aff_sub1: true,
        aff_sub2: true,
        aff_sub3: true,
        aff_sub4: false,
        aff_sub5: false,
        utm_source: true,
        utm_campaign: true,
        is_sms_blocked: false,
        is_call_blocked: false,
        sms_count_before_ban: false,
        sms_count_after_ban: false,
        call_count_before_ban: false,
        call_count_after_ban: false,
        isAdsfinSend: true,
    },
    showFilters: {
        id: false,
        email: false,
        phone: false,
        name: false,
        surname: false,
        second_name: false,
        registerDate: false,
        aff_sub1: false,
        aff_sub2: false,
        aff_sub3: false,
        aff_sub4: false,
        aff_sub5: false,
    },
    defaultFilters: {
        approved_phone: 0,
        approved_email: 0,
    },
    modals: {
        confirm_deletion: false,
        confirm_CSV: false,
        userFilters: false,
        addUsers: false,
    },
    table_data: {
        results: [],
        total: 0,
        page: 1,
    },
    checked_rows: [],
    list: {
        isLoading: false,
        users: [],
    },
};

const getters = {
    GET_USERS_FILTERS: (state) => state.filters,
    GET_SHOW_FILTERS: (state) => state.showFilters,
    GET_SHOW_COLUMNS: (state) => state.showColumns,
    GET_DEFAULT_USER_FILTERS: (state) => state.defaultFilters,
    GET_USERS_REQUEST_FILTERS: (state) => {
        const filters = Object.assign(state.defaultFilters, state.filters);
        filters.offer_ids = state.filters.offer_ids;
        filters.statuses = state.filters.statuses;
        filters.excluded_offer_ids = state.filters.excluded_offer_ids;
        filters.excluded_statuses = state.filters.excluded_statuses;
        return filters;
    },
    IS_CONFIRM_DELETION_MODAL_OPENED: (state) => state.modals.confirm_deletion,
    IS_CONFIRM_CSV_MODAL_OPENED: (state) => state.modals.confirm_CSV,
    IS_USER_FILTERS_MODAL_OPENED: (state) => state.modals.userFilters,
    IS_ADD_USERS_MODAL_OPENED: (state) => state.modals.addUsers,
    GET_TABLE_DATA: (state) => state.table_data,
    GET_CHECKED_ROWS: (state) => state.checked_rows,
};

const mutations = {
    REFRESH_USER_FILTERS: (state) => {
        for (const key in state.filters) {
            if (state.filters[key] instanceof Array) {
                state.filters[key] = [];
                continue;
            }
            if (state.filters[key] instanceof Object) {
                state.filters[key] = {value: "", typeOfSearch: ""};
                continue;
            }
            if (typeof state.filters[key] === "number") {
                delete state.filters[key];
            }
            state.filters[key] = "";
        }
    },
    REFRESH_SHOW_FILTERS: (state) => {
        for (const key in state.showFilters) {
            if (state.showFilters[key] instanceof Object) {
                state.showFilters[key] = {};
                continue;
            }
            if (typeof state.showFilters[key] instanceof Boolean) {
                state.showFilters[key] = false;
                continue;
            }
            state.showFilters[key] = false;
        }
    },
    REFRESH_SHOW_COLUMNS: (state) => {
        state.showColumns = {
            name: false,
                surname: false,
                second_name: false,
                utm_source: true,
                utm_campaign: true,
                utm_content: true,
                utm_medium: true,
                utm_term: true,
                created_at: true,
                aff_sub1: true,
                aff_sub2: true,
                aff_sub3: true,
                aff_sub5: true,
                is_sms_blocked: false,
                sms_count_before_ban: false,
                sms_count_after_ban: false,
                isAdsfinSend: true,
        };
    },
    SET_CONFIRM_DELETION_MODAL_IS_OPENED: (state, isOpen) =>
        (state.modals.confirm_deletion = isOpen),
    SET_CONFIRM_CSV_MODAL_IS_OPENED: (state, isOpen) => (state.modals.confirm_CSV = isOpen),
    SET_USER_FILTERS_MODAL_IS_OPENED: (state, isOpen) => (state.modals.userFilters = isOpen),
    SET_ADD_USERS_MODAL_IS_OPENED: (state, isOpen) => (state.modals.addUsers = isOpen),
    SET_TABLE_DATA: (state, table_data) => {
        state.table_data.results = table_data.data.results;
        state.table_data.total = table_data.data.total;
        state.table_data.page = table_data.data.page;
    },
    SET_CHECKED_ROWS: (state, rows) => (state.checked_rows = rows),
};

const actions = {
    GET_USERS: (context, params) =>
        new Promise((resolve, reject) => {
            AxiosClient.get("/profile/get_users", { params })
                .then((data) => {
                    context.commit("SET_TABLE_DATA", data);
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
    }),
    ADD_USERS: (context, form) =>
        new Promise((resolve, reject) => {
            AxiosClient.post('/profile/add_users', form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(() => {
                resolve();
            })
            .catch(() => {
                reject();
            });
    }),
    CREATE_CSV: (context, params) =>
        new Promise((resolve, reject) => {
            AxiosClient.get("/profile/create_csv", { params })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        }),
    CHANGE_BLOCK: (context, params) =>
        new Promise((resolve, reject) => {
            AxiosClient.post("/profile/change_block", { params })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        }),
    REFRESH_USER_FILTERS: (context) => context.commit("REFRESH_USER_FILTERS"),
    REFRESH_SHOW_FILTERS: (context) => context.commit("REFRESH_SHOW_FILTERS"),
    REFRESH_SHOW_COLUMNS: (context) => context.commit("REFRESH_SHOW_COLUMNS"),
    CONFIRM_DELETION_MODAL: (context, isOpen) => {
        context.commit("SET_CONFIRM_DELETION_MODAL_IS_OPENED", isOpen);
    },
    CONFIRM_CSV_MODAL: (context, isOpen) => {
        context.commit("SET_CONFIRM_CSV_MODAL_IS_OPENED", isOpen);
    },
    USER_FILTERS_MODAL: (context, isOpen) => {
        context.commit("SET_USER_FILTERS_MODAL_IS_OPENED", isOpen);
    },
    ADD_USERS_MODAL: (context, isOpen) => {
        context.commit("SET_ADD_USERS_MODAL_IS_OPENED", isOpen);
    },
    DELETE_SELECTED_USERS: (context, params) =>
        new Promise((resolve, reject) => {
            AxiosClient.post("/profile/delete_users", { params })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        }),
    CHECKED_ROWS: (context, rows) => context.commit("SET_CHECKED_ROWS", rows),
};

export default {
    state,
    getters,
    mutations,
    actions,
};
